<template>
    <modal title="Detail" :size="'xl'" @close="$emit('close')">
        <template #content>
            <pre class="m-0">{{data}}</pre>
        </template>
    </modal>
</template>

<script>
    export default {
        name:"detail",
        props:{
            data:Object
        }
    }
</script>

<style>

</style>